import { initialState } from './reducer';
import { ENTITY_DIALOG_REDUCER_KEY } from './constants';
import { createSelector } from 'reselect';

/**
 * Direct selector to the loginPage state domain
 */

const entityDialogSelector = state => state[ENTITY_DIALOG_REDUCER_KEY] || initialState;

/**
 * Other specific selectors
 */

export const getShowDialogSelector = createSelector(
  entityDialogSelector,
  entityDialog => entityDialog.showDialog || false,
);
export const getComponentNameSelector = createSelector(
  entityDialogSelector,
  entityDialog => entityDialog.componentName || false,
);
export const getDataLoadingSelector = createSelector(
  entityDialogSelector,
  entityDialog => entityDialog.isLoading || false,
);
export const getDataLoadedSelector = createSelector(
  entityDialogSelector,
  entityDialog => entityDialog.dataLoadStatus || false,
);
export const getDialogTitleSelector = createSelector(
  entityDialogSelector,
  entityDialog => entityDialog.dialogTitle || '',
);
export const getDialogTitleAppenderSelector = createSelector(
  entityDialogSelector,
  entityDialog => entityDialog.titleAppender || '',
);
export const getDialogAskConfirmationSelector = createSelector(entityDialogSelector, entityDialog => !!entityDialog.askConfirmation);
